import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/app-settings.tokens';
import { UserTypesResponse } from '../models/permissions.model';

@Injectable({
  providedIn: 'root'
})
export class UserTypeService {
  private apiUrl = `${inject(API_BASE_URL)}/api/v1/user-types`;

  constructor(private http: HttpClient) {}

  /**
   * Get all user types/roles
   * @param pageNumber - Page number (default: 1)
   * @param pageSize - Items per page (default: 10)
   * @returns Observable<UserTypesResponse>
   */
  getUserTypes(pageNumber: number = 1, pageSize: number = 10): Observable<UserTypesResponse> {
    const url = `${this.apiUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.http.get<UserTypesResponse>(url);
  }
}
